import styles from "./DateTime.module.css";

const DateTime = ({ className, onChange, value, name, ...props }) => {
    return (<input type={"datetime-local"} name={name} className={[styles.dateTime, className].filter(e => !!e).join(' ')} value={value} datetimeformat="d-M-yyyy HH:mm" onChange={onChange} {...props} />);
}
export default DateTime;